<template>
  <template
    v-if="sentMessage.link.successful.show || sentMessage.email.successful.show"
  >
    <Teleport to="#modal">
      <TheModal
        :open="
          sentMessage.link.successful.show || sentMessage.email.successful.show
        "
      >
        <ModalBody>
          <SuccessContent
            :campaignSent="
              sentMessage.link.successful.show ||
              sentMessage.email.successful.show
            "
          >
            <template #heading>
              <!-- link -->
              <template v-if="sentMessage.link.successful.show">
                <template v-if="!linkCopied">
                  <div
                    class="d-flex flex-column justify-content-center text-center"
                  >
                    <h2 class="tw-text-6xl tw-font-bold tw-text-gray-900">
                      &#127881;
                    </h2>
                    <h2 class="tw-text-3xl tw-font-bold tw-text-blue-800">
                      Your gift card link is ready to share!
                    </h2>
                  </div>
                </template>
              </template>
              <!-- email -->
              <template v-if="sentMessage.email.successful.show">
                <div
                  class="d-flex flex-column justify-content-center text-center"
                >
                  <div>
                    <img
                      style="max-height: 150px; width: auto"
                      src="../../assets/svg/illustrations-test/16_email_campaign_selection.png"
                      alt="Image Description"
                    />
                  </div>
                  <h2 class="tw-text-3xl tw-font-bold tw-text-blue-800">
                    Your email campaign is on it's way!
                  </h2>
                </div>
              </template>
            </template>
            <template #content-slot-1>
              <template v-if="sentMessage.link.successful.show">
                <template v-if="linkCopied">
                  <div
                    class="card-body d-flex gap-2 flex-column align-items-center justify-content-center"
                  >
                    <div
                      class="tw-flex tw-flex-col tw-gap-5 tw-justify-center tw-items-center"
                    >
                      <b-icon-check-square-fill
                        class="tw-text-6xl tw-font-bold tw-text-green-500"
                      ></b-icon-check-square-fill>
                      <div>
                        <h2 class="tw-text-3xl tw-font-bold tw-text-blue-800">
                          Gift card collection link copied!
                        </h2>
                        <p class="tw-text-lg tw-m-0 tw-max-w-96">
                          Paste the gift link into the email you send to your
                          prospect or client.
                        </p>
                      </div>
                      <div class="tw-flex tw-gap-4">
                        <TheButton
                          :isRouterLink="true"
                          variant="primary"
                          size="large"
                          :to="{
                            name: 'CampaignDetails',
                            params: { campaignId: this.campaign._id },
                          }"
                        >
                          <template #text>View campaign report</template>
                        </TheButton>

                        <TheButton
                          :isRouterLink="true"
                          variant="tertiary"
                          size="large"
                          to="/campaigns"
                        >
                          <template #text>Close</template>
                        </TheButton>
                      </div>
                    </div>
                  </div>
                </template>
              </template>
              <template v-if="sentMessage.email.successful.show">
                <div class="tw-flex tw-justify-center">
                  <TheButton
                    :isRouterLink="true"
                    variant="tertiary"
                    size="large"
                    :to="{
                      name: 'CampaignDetails',
                      params: { campaignId: this.campaign._id },
                    }"
                  >
                    <template #text>Close</template>
                  </TheButton>
                </div>
              </template>
            </template>

            <template #content-slot-2>
              <template v-if="sentMessage.link.successful.show">
                <template v-if="!linkCopied">
                  <div
                    class="tw-flex tw-flex-col tw-gap-4 tw-justify-center tw-items-center"
                  >
                    <div class="tw-mx-auto">
                      <TheButton
                        variant="secondary"
                        size="large"
                        @click.stop="copyLink()"
                      >
                        <template #text>Copy link</template>
                      </TheButton>
                    </div>
                    <BlockStack :gap="100" class="tw-w-lg">
                      <p class="tw-text-lg tw-m-0">
                        Copy this unique gift link—add it to the email you send
                        your prospect or client.
                      </p>
                      <p class="tw-text-lg tw-m-0">
                        You can access this link at a future date
                        <router-link
                          :to="{
                            name: 'CampaignDetails',
                            params: { campaignId: this.campaign._id },
                          }"
                          >here</router-link
                        >.
                      </p>
                    </BlockStack>
                  </div>
                </template>
              </template>
            </template>
          </SuccessContent>
        </ModalBody>
      </TheModal>
    </Teleport>
  </template>
  <NotificationMessage :scope="$options.name"></NotificationMessage>
  <PageHeader :showActions="true" title="Campaign Builder">
    <template #page-header-actions>
      <template v-if="nameEditIsActive">
        <div class="tw-flex tw-gap-2 tw-items-center">
          <input
            v-model="newCampaignName"
            type="text"
            id="campaignName"
            placeholder="Campaign name"
            class="tw-block tw-min-w-72 tw-w-full tw-rounded-md tw-border-0 tw-px-2.5 tw-py-1.5 tw-text-gray-900 tw-ring-1 tw-ring-inset tw-ring-gray-300 placeholder:tw-text-slate-900 focus:tw-ring-2 focus:tw-ring-inset focus:tw-ring-blue-600 tw-text-sm tw-leading-6"
          />
          <div class="tw-flex tw-gap-2 tw-items-center">
            <TheButton
              size="small"
              variant="success"
              :disabled="campaignIsSaving"
              @click="updateCampaign()"
            >
              <template #text>Save</template>
            </TheButton>
            <TheButton
              size="small"
              variant="tertiary"
              :disabled="campaignIsSaving"
              @click="cancelEditingCampaignName()"
            >
              <template #text>Cancel</template>
            </TheButton>
          </div>
        </div>
      </template>
      <template v-if="!nameEditIsActive">
        <div class="tw-flex tw-items-center tw-gap-2 tw-flex-wrap">
          <h2 class="tw-text-lg tw-text-blue-900 tw-m-0">
            {{ campaignName }}
          </h2>
          <TheButton
            size="small"
            variant="tertiary"
            :disabled="campaignIsSaving"
            @click="editCampaignName()"
            :hasLeadingIcon="true"
          >
            <template #leading-icon><b-icon-pencil></b-icon-pencil></template>
            <template #text>Edit name</template>
          </TheButton>
        </div>
      </template>
    </template>
  </PageHeader>

  <template v-if="!campaignIsSaving && !campaignsAreLoading">
    <nav aria-label="Progress">
      <ol
        role="list"
        class="tw-list-none tw-divide-solid tw-divide-x-0 tw-divide-y rig tw-divide-gray-300 tw-border-solid tw-bg-white tw-border tw-border-x-0 tw-border-gray-300 md:tw-flex md:tw-divide-y-0 tw-p-0 tw-m-0 twbg"
      >
        <li
          v-for="(step, stepIdx) in steps"
          :key="step.name"
          class="tw-relative md:tw-flex md:tw-flex-1"
        >
          <!-- step IS complete && NOT current && NOT step 5 -->
          <a
            v-if="step.id !== this.currentStep && step.status && step.id !== 6"
            @click.prevent="handleStepChange(step.id)"
            class="tw-group tw-flex tw-w-full tw-items-center tw-cursor-pointer"
          >
            <span
              class="tw-flex tw-items-center tw-px-6 tw-py-4 tw-text-sm tw-font-medium"
            >
              <span
                class="tw-flex tw-w-8 tw-h-8 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-green-50"
              >
                <span class="tw-text-green-600 tw-text-xl"
                  ><b-icon-check></b-icon-check
                ></span>
              </span>
              <span
                class="tw-ml-4 tw-text-sm tw-font-medium tw-text-gray-900"
                >{{ step.name }}</span
              >
            </span>
          </a>
          <!-- step IS complete && IS current && NOT step 5 -->
          <a
            v-else-if="
              step.id === this.currentStep && step.status && step.id !== 6
            "
            @click.prevent="handleStepChange(step.id)"
            class="tw-group tw-flex tw-w-full tw-items-center tw-cursor-pointer"
          >
            <span
              class="tw-flex tw-items-center tw-px-6 tw-py-4 tw-text-sm tw-font-medium"
            >
              <span
                class="tw-flex tw-w-8 tw-h-8 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-green-100 tw-border-3 tw-border-solid tw-border-green-600"
              >
                <span class="tw-text-green-600 tw-text-xl"
                  ><b-icon-check></b-icon-check
                ></span>
              </span>
              <span class="tw-ml-4 tw-text-sm tw-font-bold tw-text-green-600">{{
                step.name
              }}</span>
            </span>
          </a>
          <!-- step IS NOT complete && NOT current && NOT step 5 -->
          <a
            v-else-if="
              step.id !== this.currentStep && !step.status && step.id !== 6
            "
            @click="handleStepChange(step.id)"
            class="tw-group tw-flex tw-w-full tw-items-center tw-cursor-pointer"
          >
            <span
              class="tw-flex tw-items-center tw-px-6 tw-py-4 tw-text-sm tw-font-medium"
            >
              <span
                class="tw-flex tw-w-8 tw-h-8 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-red-50"
              >
                <span class="tw-text-red-600 tw-text-xl"
                  ><b-icon-exclamation></b-icon-exclamation
                ></span>
              </span>
              <span
                class="tw-ml-4 tw-text-sm tw-font-medium tw-text-gray-900"
                >{{ step.name }}</span
              >
            </span>
          </a>
          <!-- step IS NOT complete && IS current && NOT step 5 -->
          <a
            v-else-if="
              step.id === this.currentStep && !step.status && step.id !== 6
            "
            @click="handleStepChange(step.id)"
            class="tw-group tw-flex tw-w-full tw-items-center tw-cursor-pointer"
          >
            <span
              class="tw-flex tw-items-center tw-px-6 tw-py-4 tw-text-sm tw-font-medium"
            >
              <span
                class="tw-flex tw-w-8 tw-h-8 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-border-solid tw-bg-red-100 tw-border-3 tw-red-solid tw-border-red-600"
              >
                <span class="tw-text-red-600 tw-text-xl"
                  ><b-icon-exclamation></b-icon-exclamation
                ></span>
              </span>
              <span class="tw-ml-4 tw-text-sm tw-font-bold tw-text-red-600">{{
                step.name
              }}</span>
            </span>
          </a>

          <!-- IS NOT current && IS step 5 -->
          <button
            v-if="step.id !== this.currentStep && step.id === 6"
            :disabled="!allStepsComplete || !campaignIsComplete"
            @click="handleStepChange(step.id)"
            class="tw-border-0 tw-bg-transparent tw-group tw-flex tw-items-center disabled:tw-cursor-not-allowed tw-cursor-pointer"
          >
            <span
              class="tw-flex tw-items-center tw-px-6 tw-py-4 tw-text-sm tw-font-medium"
            >
              <span
                class="tw-flex tw-h-8 tw-w-8 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-border-2 group-hover:tw-border-gray-900"
                :class="{
                  'tw-text-red-500 tw-bg-gray-100 ':
                    !allStepsComplete || !campaignIsComplete,
                  'tw-text-gray-500 group-hover:tw-text-gray-900 tw-bg-blue-100':
                    allStepsComplete,
                }"
              >
                <span
                  :class="{
                    'tw-text-red-500 tw-font-medium':
                      !allStepsComplete || !campaignIsComplete,
                    'tw-text-gray-900 tw-font-bold': allStepsComplete,
                  }"
                  >{{ step.id }}</span
                >
              </span>
              <span
                class="tw-ml-4 tw-text-sm tw-text-start"
                :class="{
                  'tw-text-red-500 tw-font-medium':
                    !allStepsComplete || !campaignIsComplete,
                  'tw-text-gray-900 tw-font-bold': allStepsComplete,
                }"
              >
                {{
                  allStepsComplete && campaignIsComplete
                    ? step.name
                    : "Complete all steps to review"
                }}
              </span>
            </span>
          </button>
          <!-- IS current && IS step 5 -->
          <a
            v-if="step.id === this.currentStep && step.id === 6"
            class="tw-border-0 tw-bg-transparent tw-group tw-flex tw-items-center"
          >
            <span
              class="tw-flex tw-items-center tw-px-6 tw-py-4 tw-text-sm tw-font-medium"
            >
              <span
                class="tw-flex tw-h-8 tw-w-8 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-border-2 group-hover:tw-border-gray-900"
                :class="{
                  'tw-text-red-500 tw-bg-gray-100 ': !allStepsComplete,
                  'tw-text-gray-500 group-hover:tw-text-gray-900 tw-bg-blue-100':
                    allStepsComplete,
                }"
              >
                <span
                  :class="{
                    'tw-text-red-500 tw-font-medium': !allStepsComplete,
                    'tw-text-gray-900 tw-font-bold': allStepsComplete,
                  }"
                  >{{ step.id }}</span
                >
              </span>
              <span
                class="tw-ml-4 tw-text-sm tw-text-start"
                :class="{
                  'tw-text-red-500 tw-font-medium': !allStepsComplete,
                  'tw-text-gray-900 tw-font-bold': allStepsComplete,
                }"
              >
                {{
                  allStepsComplete ? step.name : "Complete all steps to review"
                }}
              </span>
            </span>
          </a>

          <template v-if="stepIdx !== steps.length - 1">
            <div
              class="tw-absolute tw-right-0 tw-top-0 tw-hidden tw-h-full tw-w-5 md:tw-block"
              aria-hidden="true"
            >
              <svg
                class="tw-h-full tw-w-full tw-text-gray-300"
                viewBox="0 0 22 80"
                fill="none"
                preserveAspectRatio="none"
              >
                <path
                  d="M0 -2L20 40L0 82"
                  vector-effect="non-scaling-stroke"
                  stroke="currentcolor"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </template>
        </li>
      </ol>
    </nav>
  </template>
  <template v-if="campaignsAreLoading || campaignIsSaving">
    <ThePage customWidthClass="tw-w-full tw-max-w-5xl tw-mx-auto">
      <div
        class="tw-flex tw-justify-center tw-items-center tw-w-full tw-h-full tw-max-h-2xl tw-max-w-2xl tw-m-auto"
      >
        <PageSection :fullWidth="true">
          <PulseAnimation>
            <ListSkeleton :numberOfRows="5"></ListSkeleton>
          </PulseAnimation>
        </PageSection>
      </div>
    </ThePage>
  </template>

  <template
    v-if="currentStep === 1 && !campaignsAreLoading && !campaignIsSaving"
  >
    <ThePage customWidthClass="tw-w-full tw-max-w-5xl tw-mx-auto">
      <PageSection
        :title="recipientPageSectionTitle"
        class="tw-w-full"
        :showTooltip="this?.campaign?.recipients?.length > 1"
        :tooltipContent="recipientsSectionTooltipContent"
        :showActions="this?.campaign?.recipients?.length > 0"
      >
        <template
          #page-header-actions
          v-if="this?.campaign?.recipients?.length > 0"
        >
          <div class="tw-flex tw-gap-3">
            <TheLink variant="primary" @click="toggleCampaignRecipients()">
              <template #text>
                {{
                  !showCampaignRecipients
                    ? "View selected recipients"
                    : "Add more recipients"
                }}
              </template>
            </TheLink>
          </div>
        </template>
        <template
          v-if="
            campaignRecipients.length === 0 ||
            (campaignRecipients.length > 0 && !showCampaignRecipients)
          "
        >
          <RecipientsIndexTableV2
            :campaignId="this.campaign._id"
            :campaignView="true"
            @setCampaignRecipients="setCampaignRecipients"
          >
          </RecipientsIndexTableV2>
        </template>
        <template
          v-if="campaignRecipients.length > 0 && showCampaignRecipients"
        >
          <div class="tw-flex tw-flex-col tw-w-full">
            <!-- <AlertMessage alertType="WARNING">
              <template #alertMessage>Multi-recipient campaigns</template>
            </AlertMessage> -->
            <CampaignRecipientsSelection
              :campaignRecipients="this?.campaign?.recipients"
              @removeSelectedCampaignRecipients="
                removeSelectedCampaignRecipients
              "
              @toggleCampaignRecipients="toggleCampaignRecipients"
            >
            </CampaignRecipientsSelection>
          </div>
        </template>
      </PageSection>
    </ThePage>
  </template>
  <template
    v-if="currentStep === 2 && !campaignsAreLoading && !campaignIsSaving"
  >
    <ThePage class="tw-max-w-lg tw-mx-auto">
      <TheCard>
        <CardHeader
          :showTitle="true"
          title="Set your gift card amount"
        ></CardHeader>
        <!-- <div class="tw-bg-black"> -->
        <CardBody>
          <TheBox>
            <div
              class="tw-p-5 tw-flex tw-flex-col tw-gap-10 tw-items-center tw-justify-center"
            >
              <div
                class="tw-flex tw-flex-col tw-gap-5 tw-items-center tw-justify-center"
              >
                <h2
                  class="tw-text-5xl tw-font-bold tw-leading-6"
                  :class="{
                    'tw-text-red-500': this.giftCardAmount == 0,
                    'tw-text-blue-500': this.giftCardAmount != 0,
                  }"
                >
                  ${{ giftCardAmount }}
                </h2>
                <span class="tw-isolate tw-inline-flex tw-rounded-md">
                  <button
                    type="button"
                    @click="setGiftCardAmount(10)"
                    class="tw-border-none disabled:tw-bg-slate-300 tw-relative tw-inline-flex tw-items-center tw-rounded-l-md tw-bg-white tw-px-3 tw-py-2 tw-text-lg tw-font-semibold tw-text-gray-900 tw-ring-1 tw-ring-inset tw-ring-gray-300 hover:tw-bg-gray-50 focus:tw-z-10"
                  >
                    $10
                  </button>
                  <button
                    type="button"
                    @click="setGiftCardAmount(15)"
                    class="tw-border-none disabled:tw-bg-slate-300 tw-relative tw--ml-px tw-inline-flex tw-items-center tw-bg-white tw-px-3 tw-py-2 tw-text-lg tw-font-semibold tw-text-gray-900 tw-ring-1 tw-ring-inset tw-ring-gray-300 hover:tw-bg-gray-50 focus:tw-z-10"
                  >
                    $15
                  </button>
                  <button
                    type="button"
                    @click="setGiftCardAmount(25)"
                    class="tw-border-none disabled:tw-bg-slate-300 tw-relative tw--ml-px tw-inline-flex tw-items-center tw-bg-white tw-px-3 tw-py-2 tw-text-lg tw-font-semibold tw-text-gray-900 tw-ring-1 tw-ring-inset tw-ring-gray-300 hover:tw-bg-gray-50 focus:tw-z-10"
                  >
                    $25
                  </button>
                  <button
                    type="button"
                    @click="setGiftCardAmount(50)"
                    class="tw-border-none tw-relative tw--ml-px tw-inline-flex tw-items-center tw-rounded-r-md tw-bg-white tw-px-3 tw-py-2 tw-text-lg tw-font-semibold tw-text-gray-900 tw-ring-1 tw-ring-inset tw-ring-gray-300 hover:tw-bg-gray-50 focus:tw-z-10"
                  >
                    $50
                  </button>
                </span>
              </div>
              <template v-if="campaign?.metadata">
                <div>
                  <div class="tw-text-start">
                    <p
                      class="tw-text-lg tw-font-bold tw-leading-6 tw-text-gray-900 tw-text-center tw-m-0"
                    >
                      Or add a custom gift card amount
                    </p>
                    <p
                      class="tw-text-sm tw-font-bold tw-leading-6 tw-text-gray-500 tw-m-0"
                    >
                      Amount must be a whole number of $5 or more
                    </p>
                  </div>

                  <div class="tw-relative tw-rounded-md tw-shadow-sm tw-w-auto">
                    <div
                      class="tw-pointer-events-none tw-absolute tw-inset-y-0 tw-left-0 tw-flex tw-items-center tw-pl-3"
                    >
                      <b-icon-currency-dollar
                        class="tw-h-5 tw-w-5 tw-text-gray-400"
                        aria-hidden="true"
                      ></b-icon-currency-dollar>
                    </div>
                    <input
                      v-model="campaign.metadata.gift_card_amount"
                      @input="validateCustomGiftCardValue"
                      type="text"
                      name="campaignSearch"
                      id="giftCardAmount"
                      class="tw-block tw-w-full tw-rounded-md tw-border-0 tw-px-2.5 tw-py-2 tw-pl-10 tw-text-gray-900 tw-ring-1 tw-ring-inset tw-ring-gray-300 placeholder:tw-text-slate-900 focus:tw-ring-2 focus:tw-ring-inset focus:tw-ring-blue-600 tw-text-lg tw-leading-6"
                      placeholder="Add gift card amount"
                    />
                  </div>
                </div>
              </template>
            </div>
          </TheBox>
        </CardBody>
        <!-- </div> -->
      </TheCard>
    </ThePage>
  </template>
  <template
    v-if="currentStep === 3 && !campaignsAreLoading && !campaignIsSaving"
  >
    <GiftCardsGridV2
      @updateCampaignCustomSelection="updateCampaignCustomSelection"
      :campaign="campaign"
      :custom_selection_ids="customSelection"
      :isCampaignBuilder="true"
    >
    </GiftCardsGridV2>
  </template>
  <template
    v-if="currentStep === 4 && !campaignsAreLoading && !campaignIsSaving"
  >
    <ThePage :autoWidth="true">
      <template v-if="!campaignType || campaignType === 'link'">
        <div class="tw-w-full tw-flex tw-justify-center tw-gap-x-10">
          <!-- <template> -->
          <div
            class="hover:tw-opacity-90 tw-cursor-pointer tw-z-0 tw-w-72 tw-shadow tw-bg-white tw-rounded-lg tw-p-2"
            :class="{
              'tw-border-solid tw-border tw-border-blue-500':
                campaignType === 'link',
            }"
            @click="setCampaignType('link')"
          >
            <div class="tw-relative">
              <template v-if="campaignType === 'link'">
                <b-icon-check-circle-fill
                  class="tw-absolute tw-top-2 tw-right-2 tw-h-10 tw-w-10 tw-border-gray-300 tw-text-yellow-400 tw-bg-blue-500 tw-rounded-full focus:tw-ring-blue-600 tw-z-10"
                ></b-icon-check-circle-fill>
              </template>
              <template v-else>
                <b-icon-check-circle
                  class="tw-absolute tw-top-2 tw-right-2 tw-h-10 tw-w-10 tw-rounded tw-border-gray-300 tw-text-gray-600 focus:tw-ring-blue-600 tw-z-10"
                ></b-icon-check-circle>
              </template>
              <div
                class="tw-aspect-h-10 tw-aspect-w-10 tw-w-full tw-overflow-hidden tw-rounded tw-bg-blue-100"
              >
                <img
                  src="../../assets/svg/illustrations-test/25_link_campaign_selection.png"
                  alt=""
                  class="tw-p-10 tw-h-full tw-w-full tw-pointer-events-none tw-object-cover"
                />
              </div>
            </div>
            <div class="tw-p-2 tw-pt-4 tw-text-start">
              <h2 class="tw-text-2xl tw-font-bold tw-text-gray-900">
                Create shareable link
              </h2>
              <p
                class="tw-pointer-events-none tw-mt-2 tw-text-lg tw-m-0 tw-text-gray-900"
              >
                Create a shareable link that seamlessly integrates into your
                existing workflow.
              </p>
            </div>
          </div>
          <!-- </template> -->
          <!-- <template> -->
          <div
            class="hover:tw-opacity-90 tw-cursor-pointer tw-z-0 tw-w-72 tw-shadow tw-bg-white tw-rounded-lg tw-p-2"
            :class="{
              'tw-border-solid tw-border tw-border-blue-500':
                campaignType === 'email',
              'tw-relative tw-opacity-30': campaignRecipients.length > 1,
            }"
            @click="conditionallySetCampaignTypeToEmail()"
          >
            <div class="tw-relative">
              <template v-if="campaignType === 'email'">
                <b-icon-check-circle-fill
                  class="tw-absolute tw-top-2 tw-right-2 tw-h-10 tw-w-10 tw-border-gray-300 tw-text-yellow-400 tw-bg-blue-500 tw-rounded-full focus:tw-ring-blue-600 tw-z-10"
                ></b-icon-check-circle-fill>
              </template>
              <template v-else>
                <b-icon-check-circle
                  class="tw-absolute tw-top-2 tw-right-2 tw-h-10 tw-w-10 tw-rounded tw-border-gray-300 tw-text-gray-600 focus:tw-ring-blue-600 tw-z-10"
                ></b-icon-check-circle>
              </template>

              <div
                class="tw-aspect-h-10 tw-aspect-w-10 tw-w-full tw-overflow-hidden tw-rounded tw-bg-blue-100"
              >
                <img
                  src="../../assets/svg/illustrations-test/16_email_campaign_selection.png"
                  alt=""
                  class="tw-p-10 tw-h-full tw-w-full tw-pointer-events-none tw-object-cover"
                />
              </div>
            </div>
            <div class="tw-p-2 tw-pt-4 tw-text-start">
              <h2 class="tw-text-2xl tw-font-bold tw-text-gray-900">
                Send email
              </h2>
              <p
                class="tw-pointer-events-none tw-mt-2 tw-text-lg tw-m-0 tw-text-gray-900"
              >
                Use our email builder to send emails with embedded e-gift card
                links in minutes.
              </p>
            </div>
            <template v-if="campaignRecipients.length > 1">
              <div
                class="tw-absolute tw-border-solid tw-border-orange-300 tw-border-4 tw-border-b-0 tw-border-x-0 tw-top-0 tw-right-0 tw-h-full tw-w-full tw-flex tw-opacity-0 hover:tw-opacity-100 tw-z-20"
                aria-hidden="true"
              >
                <div
                  class="tw-h-full tw-rounded-md tw-bg-white tw-px-4 py-2 tw-text-center tw-text-gray-900 tw-backdrop-blur tw-backdrop-filter"
                >
                  <p class="tw-mt-2 tw-text-lg tw-m-0 tw-text-left">
                    Multi-recipient campaigns can only be sent using our
                    shareable link. To use our email builder update your
                    recipient selection or create a single-recipient campaign.
                  </p>
                </div>
              </div>
            </template>
          </div>
          <!-- </template> -->
        </div>
      </template>

      <!-- <template v-else> -->
      <template v-if="campaignType === 'email'">
        <div class="tw-flex tw-flex-col gap-2 tw-w-full">
          <div class="tw-flex tw-flex-wrap tw-gap-x-3 tw-gap-y-3">
            <div
              class="tw-h-16 tw-w-16 tw-overflow-hidden tw-rounded tw-bg-white tw-p-1"
            >
              <img
                src="../../assets/svg/illustrations-test/16_email_campaign_selection.png"
                alt=""
                class="tw-h-full tw-w-full tw-p-1 tw-bg-blue-100 tw-pointer-events-none tw-object-cover"
              />
            </div>
            <div
              class="tw-flex tw-gap-x-3 tw-items-center tw-flex-grow tw-flex-wrap"
            >
              <h2
                class="tw-text-2xl tw-font-bold tw-text-gray-900 tw-m-0 tw-flex-grow"
              >
                Email builder
              </h2>
              <TheLink variant="tertiary" @click="setCampaignType('link')">
                <template #text>Use shareable link instead</template>
              </TheLink>
            </div>
          </div>
          <div class="tw-flex tw-flex-wrap tw-gap-4">
            <TheCard>
              <TheBox :withPadding="true">
                <CardBody :withPadding="true">
                  <BlockStack :gap="400" class="tw-w-full">
                    <BlockStack :gap="300" class="tw-w-full">
                      <h2
                        class="tw-text-lg tw-font-semibold tw-text-gray-900 tw-m-0"
                      >
                        Subject
                      </h2>
                      <BlockStack :gap="100" class="tw-w-full">
                        <input
                          v-model="campaign.subject"
                          type="text"
                          name="campaignSubject"
                          id="campaignSubject"
                          :class="{ 'tw-ring-red-300': !campaignSubject }"
                          class="tw-block tw-w-96 tw-rounded-md tw-border-0 tw-px-2.5 tw-py-1.5 tw-text-gray-900 tw-ring-1 tw-ring-inset tw-ring-gray-300 placeholder:tw-text-slate-900 focus:tw-ring-2 focus:tw-ring-inset focus:tw-ring-blue-600 tw-text-lg tw-leading-6"
                          placeholder=""
                        />
                        <template v-if="!campaignSubject">
                          <p class="tw-text-red-500 tw-m-0">required</p>
                        </template>
                      </BlockStack>
                    </BlockStack>
                    <BlockStack :gap="300" class="tw-w-full">
                      <h2
                        class="tw-text-lg tw-font-semibold tw-text-gray-900 tw-m-0"
                      >
                        Body
                      </h2>
                      <BlockStack :gap="200" class="tw-w-full">
                        <textarea
                          rows="10"
                          v-model="campaign.text"
                          name="emailContent"
                          id="emailContent"
                          :class="{ 'tw-ring-red-300': !campaignText }"
                          class="tw-block tw-p-4 tw-w-full tw-rounded-lg tw-border-0 tw-border-solid tw-text-gray-900 tw-shadow tw-ring-1 tw-ring-inset tw-ring-gray-300 placeholder:tw-text-gray-400 focus:tw-ring-2 focus:tw-ring-inset focus:tw-ring-blue-600 sm:tw-text-lg"
                        ></textarea>
                        <template v-if="!campaignText">
                          <p class="tw-text-red-500 tw-m-0">required</p>
                        </template>
                      </BlockStack>
                    </BlockStack>
                  </BlockStack>
                </CardBody>
              </TheBox>
            </TheCard>
            <TheCard :autoWidth="true" class="tw-grow">
              <CardHeader :showTitle="true" title="Email preview"> </CardHeader>
              <div class="tw-rounded-lg tw-overflow-hidden tw-shadow">
                <table
                  id="main_table"
                  style="
                    border-collapse: collapse;
                    text-align: center;
                    background-color: #fff;
                    width: 100%;
                    border: 1px solid #efeeea;
                  "
                >
                  <tr>
                    <td
                      id="email_from_container"
                      style="
                        padding: 24px;
                        padding-bottom: 0px;
                        text-align: left;
                        background-color: #fff;
                      "
                    >
                      <p style="margin: 0; color: rgb(0, 0, 0)">
                        {{ campaignFromName }} sent you an
                        <span style="font-weight: bold">STL eGift card</span>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td
                      id="email_text_container"
                      style="
                        padding: 24px;
                        text-align: left;
                        background-color: #fff;
                        min-height: 200px;
                      "
                    >
                      <template v-if="campaignText">
                        <div
                          style="min-height: 150px"
                          v-html="generatedHtml"
                        ></div>
                      </template>
                      <template v-else>
                        <div
                          class="tw-border-l-4 tw-border-orange-400 tw-bg-orange-50 tw-p-4 tw-border-y-0 tw-border-r-0 tw-border-solid tw-flex tw-items-center tw-gap-4"
                        >
                          <img
                            style="max-height: 100px; width: auto"
                            src="../../assets/svg/illustrations-test/75_pencil.png"
                            alt="Image Description"
                          />
                          <p class="tw-text-lg tw-m-0 tw-text-start">
                            Your message will show up here.
                          </p>
                        </div>
                      </template>
                    </td>
                  </tr>
                  <tr>
                    <td
                      id="email_accept_container"
                      style="padding: 24px; background-color: #f6f6f4"
                    >
                      <table
                        id="nested_table_1"
                        style="
                          width: 100%;
                          margin: 0 auto;
                          border-collapse: collapse;
                        "
                      >
                        <tr>
                          <td
                            id="nested_table_1_td_1"
                            style="
                              text-align: left;
                              padding-right: 5px;
                              vertical-align: middle;
                              height: 100%;
                              max-width: 70%;
                            "
                          >
                            <p
                              style="
                                margin: 0;
                                color: rgb(0, 0, 0);
                                font-size: 16px;
                              "
                            >
                              Powered by
                              <span style="font-weight: bold"
                                >Bold Xchange</span
                              >
                            </p>
                            <p style="margin: 5px 0 0; color: rgb(0, 0, 0)">
                              Enjoy an eGift card marketplace featuring many of
                              St. Louis’ best small businesses.
                            </p>
                          </td>
                          <td
                            id="nested_table_1_td_2"
                            style="
                              text-align: center;
                              padding: 0;
                              height: 100%;
                              width: 30%;
                            "
                          >
                            <span
                              style="
                                text-align: center;
                                background-color: #004aad;
                                border-radius: 6px;
                                color: #ffcc48;
                                font-weight: bold;
                                font-style: normal;
                                padding: 16px 24px;
                                font-size: 16px;
                                text-decoration: none;
                                display: inline-block;
                                width: auto;
                              "
                              >Accept</span
                            >
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td
                      id="email_contact_container"
                      style="padding: 24px; background-color: #fff"
                    >
                      <table
                        id="nested_table_2"
                        style="
                          width: 100%;
                          margin: 0 auto;
                          border-collapse: collapse;
                        "
                      >
                        <tr>
                          <td>
                            <a
                              href="https://boldxchange.com"
                              target="_blank"
                              rel="noopener noreferrer"
                              style="color: rgb(0, 0, 0)"
                            >
                              <img
                                alt="Gifting Powered by Bold Xchange"
                                title="Bold Xchange"
                                src="https://storage.googleapis.com/boldxchange-public/Bold_Xchange_PrimaryLogo_Black_Email.png"
                                style="width: 175px; height: auto"
                              />
                            </a>
                            <p style="margin: 10px 0 0; color: rgb(0, 0, 0)">
                              Bold Xchange P.O Box 771576 St. Louis, MO 63177
                            </p>
                            <p
                              style="
                                margin: 0;
                                margin-bottom: 0;
                                color: rgb(0, 0, 0);
                              "
                            >
                              <a
                                style="
                                  text-decoration: underline;
                                  color: rgb(7, 7, 7);
                                "
                                href="mailto:gifts@boldxchange.com"
                                >gifts@boldxchange.com</a
                              >
                            </p>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td
                      id="email_copyright_container"
                      style="
                        padding: 24px;
                        text-align: center;
                        background-color: #fff;
                      "
                    >
                      <p
                        style="
                          text-align: center;
                          background-color: #fff;
                          margin: 0;
                          color: rgb(7, 7, 7);
                        "
                      >
                        <em> Copyright (C) 2024 Bold Xchange, Inc.</em>
                      </p>
                    </td>
                  </tr>
                </table>
              </div>
            </TheCard>
          </div>
        </div>
      </template>
      <!-- </template> -->
    </ThePage>
  </template>
  <template
    v-if="currentStep === 5 && !campaignsAreLoading && !campaignIsSaving"
  >
    <ThePage customWidthClass="tw-max-w-5xl tw-mx-auto">
      <PageSection title="Gift Redemption Terms" class="tw-w-full">
        <template v-if="!hasGoogleTokens && !hasOffice365Tokens">
          <p class="tw-text-xl tw-leading-8 tw-text-gray-700">
            Bold Xchange allows you to require a recipient to take a meeting
            with you in order to accept their gift. Connect your account to have
            meetings booked on your calendar in real-time any time a lead
            accepts your e-gift terms.
          </p>
        </template>
        <!-- google -->
        <TheCard>
          <TheBox :withPadding="true">
            <div class="tw-flex tw-justify-between tw-gap-2 tw-w-auto tw-p-2">
              <div class="tw-flex tw-items-center tw-h-full tw-gap-4">
                <!-- logo -->
                <div class="tw-h-10 tw-w-auto tw-flex-shrink-0 tw-rounded">
                  <img
                    src="../../assets/svg/brands/google-icon.svg"
                    alt="google logo"
                    class="tw-h-full tw-w-auto tw-flex-shrink-0 tw-mx-auto"
                  />
                </div>
                <div>
                  <p
                    class="tw-m-0 tw-font-semibold tw-text-indigo-400 tw-uppercase tw-text-xs"
                  >
                    sync calendar
                  </p>
                  <h2
                    class="tw-text-2xl tw-m-0 tw-font-bold tw-tracking-tight tw-text-gray-900 tw-sm:text-lg"
                  >
                    Google
                  </h2>
                </div>
              </div>
              <template v-if="hasGoogleTokens">
                <div class="tw-flex tw-gap-2 tw-items-center tw-text-sm">
                  <b-icon-check-circle-fill
                    class="tw-text-green-500"
                  ></b-icon-check-circle-fill>
                  <p class="tw-m-0 tw-font-semibold tw-text-text-400">
                    Account connected
                  </p>
                </div>
              </template>
              <template v-else>
                <div>
                  <TheButton
                    :hasLeadingIcon="true"
                    variant="primary"
                    @click="startLinkingGoogle()"
                    size="large"
                  >
                    <template #text> Connect </template>
                  </TheButton>
                </div>
              </template>
            </div>
            <template v-if="hasGoogleTokens">
              <BlockStack :gap="400" class="tw-grow">
                <div>
                  <p class="tw-text-lg tw-leading-8 tw-text-gray-700 tw-mt-2">
                    Do you want require a recipient to accept a
                    <span class="tw-font-bold tw-text-gray-900">Google</span>
                    calendar invite in order to redeem their gift?
                  </p>
                  <div
                    class="tw-flex tw-items-center tw-gap-4 tw-p-4"
                    :class="{
                      'tw-bg-green-50': calendarState.google,
                      'tw-bg-orange-50': !calendarState.google,
                    }"
                  >
                    <input
                      type="checkbox"
                      class="tw-h-10 tw-w-10 tw-border-gray-300 tw-text-blue-600 focus:tw-ring-blue-600"
                      id="selectGoogleCalendar"
                      name="calendarSelection"
                      value="google"
                      :checked="calendarState.google"
                      @change="handleCalendarSelection('google')"
                    />
                    <label
                      for="selectGoogleCalendar"
                      class="tw-text-lg tw-gray-blue-700 tw--mt-1 tw-mb-0"
                    >
                      Yes, require campaign recipients to accept a Google
                      calendar invite in order to redeem their gift.
                    </label>
                  </div>
                </div>
                <template v-if="calendarState.google">
                  <BlockStack :gap="300" class="tw-grow">
                    <BlockStack :gap="100" class="tw-grow">
                      <label
                        for="bookingSummary"
                        class="tw-text-lg tw-font-medium tw-leading-6 tw-text-gray-900"
                        >Meeting title<span
                          v-if="!campaign.booking.summary"
                          class="tw-text-red-500 tw-m-0 tw-text-sm tw-ms-2 tw-bg-red-50 tw-py-1 tw-px-2 tw-rounded"
                          >required field</span
                        ></label
                      >
                      <input
                        v-model="campaign.booking.summary"
                        type="text"
                        name="bookingSummary"
                        id="bookingSummary"
                        :class="{
                          'tw-ring-red-300': !campaign.booking.summary,
                          'tw-ring-green-500': campaign.booking.summary,
                        }"
                        class="tw-block tw-w-full tw-rounded-md tw-border-0 tw-px-4 tw-py-4 tw-text-gray-900 tw-ring-1 tw-ring-inset tw-ring-gray-300 placeholder:tw-text-gray-400 focus:tw-ring-2 focus:tw-ring-inset focus:tw-ring-blue-600 tw-text-lg tw-leading-6"
                        placeholder="Add meeting title"
                      />
                    </BlockStack>
                    <BlockStack :gap="100" class="tw-grow">
                      <label
                        for="bookingDescription"
                        class="tw-text-lg tw-font-medium tw-leading-6 tw-text-gray-900"
                        >Meeting summary<span
                          v-if="!campaign.booking.description"
                          class="tw-text-red-500 tw-m-0 tw-text-sm tw-ms-2 tw-bg-red-50 tw-py-1 tw-px-2 tw-rounded"
                          >required field</span
                        ></label
                      >
                      <textarea
                        rows="10"
                        v-model="campaign.booking.description"
                        name="bookingDescription"
                        id="bookingDescription"
                        :class="{
                          'tw-ring-red-300': !campaign.booking.description,
                          'tw-ring-green-500': campaign.booking.description,
                        }"
                        class="tw-block tw-p-4 tw-w-full tw-rounded-lg tw-border-0 tw-border-solid tw-text-gray-900 tw-shadow tw-ring-1 tw-ring-inset tw-ring-gray-300 placeholder:tw-text-gray-400 focus:tw-ring-2 focus:tw-ring-inset focus:tw-ring-blue-600 sm:tw-text-lg"
                      ></textarea>
                    </BlockStack>
                  </BlockStack>
                </template>
              </BlockStack>
            </template>
            <template v-else>
              <p class="tw-text-xl tw-leading-8 tw-text-gray-700 tw-mt-3">
                Connect your Google account to require a recipient to take a
                meeting with you in order to accept their gift and have meetings
                booked on your calendar in real-time any time a lead accepts
                your e-gift terms.
              </p>
            </template>
          </TheBox>
        </TheCard>
        <!-- office365 -->
        <TheCard>
          <TheBox :withPadding="true">
            <div class="tw-flex tw-justify-between tw-gap-2 tw-w-auto tw-p-2">
              <div class="tw-flex tw-items-center tw-h-full tw-gap-4">
                <!-- logo -->
                <div class="tw-h-10 tw-w-auto tw-flex-shrink-0 tw-rounded">
                  <img
                    src="../../assets/svg/brands/office365.png"
                    alt="office365 logo"
                    class="tw-h-full tw-w-auto tw-flex-shrink-0 tw-mx-auto"
                  />
                </div>
                <div>
                  <p
                    class="tw-m-0 tw-font-semibold tw-text-indigo-400 tw-uppercase tw-text-xs"
                  >
                    sync calendar
                  </p>
                  <h2
                    class="tw-text-2xl tw-m-0 tw-font-bold tw-tracking-tight tw-text-gray-900 tw-sm:text-lg"
                  >
                    Office365
                  </h2>
                </div>
              </div>
              <template v-if="hasOffice365Tokens">
                <div class="tw-flex tw-gap-2 tw-items-center tw-text-sm">
                  <b-icon-check-circle-fill
                    class="tw-text-green-500"
                  ></b-icon-check-circle-fill>
                  <p class="tw-m-0 tw-font-semibold tw-text-text-400">
                    Account connected
                  </p>
                </div>
              </template>
              <template v-else>
                <div>
                  <TheButton
                    :hasLeadingIcon="true"
                    variant="primary"
                    @click="startLinkingOffice365()"
                    size="large"
                  >
                    <template #text> Connect </template>
                  </TheButton>
                </div>
              </template>
            </div>
            <template v-if="hasOffice365Tokens">
              <BlockStack :gap="400" class="tw-grow">
                <div>
                  <p class="tw-text-lg tw-leading-8 tw-text-gray-700 tw-mt-2">
                    Do you want require a recipient to accept a
                    <span class="tw-font-bold tw-text-gray-900">Office365</span>
                    calendar invite in order to redeem their gift?
                  </p>
                  <div
                    class="tw-flex tw-items-center tw-gap-4 tw-p-4"
                    :class="{
                      'tw-bg-green-50': calendarState.office365,
                      'tw-bg-orange-50': !calendarState.office365,
                    }"
                  >
                    <input
                      type="checkbox"
                      class="tw-h-10 tw-w-10 tw-border-gray-300 tw-text-blue-600 focus:tw-ring-blue-600"
                      id="selectOffice365Calendar"
                      name="calendarSelection"
                      value="office365"
                      :checked="calendarState.office365"
                      @change="handleCalendarSelection('office365')"
                    />
                    <label
                      for="selectOffice365Calendar"
                      class="tw-text-lg tw-gray-blue-700 tw--mt-1 tw-mb-0"
                    >
                      Yes, require campaign recipients to accept a Office365
                      calendar invite in order to redeem their gift.
                    </label>
                  </div>
                </div>
                <template v-if="calendarState.office365">
                  <BlockStack :gap="300" class="tw-grow">
                    <BlockStack :gap="100" class="tw-grow">
                      <label
                        for="bookingSummary"
                        class="tw-text-lg tw-font-medium tw-leading-6 tw-text-gray-900"
                        >Meeting title<span
                          v-if="!campaign.booking.summary"
                          class="tw-text-red-500 tw-m-0 tw-text-sm tw-ms-2 tw-bg-red-50 tw-py-1 tw-px-2 tw-rounded"
                          >required field</span
                        ></label
                      >
                      <input
                        v-model="campaign.booking.summary"
                        type="text"
                        name="bookingSummary"
                        id="bookingSummary"
                        :class="{
                          'tw-ring-red-300': !campaign.booking.summary,
                          'tw-ring-green-500': campaign.booking.summary,
                        }"
                        class="tw-block tw-w-full tw-rounded-md tw-border-0 tw-px-4 tw-py-4 tw-text-gray-900 tw-ring-1 tw-ring-inset tw-ring-gray-300 placeholder:tw-text-gray-400 focus:tw-ring-2 focus:tw-ring-inset focus:tw-ring-blue-600 tw-text-lg tw-leading-6"
                        placeholder="Add meeting title"
                      />
                    </BlockStack>
                    <BlockStack :gap="100" class="tw-grow">
                      <label
                        for="bookingDescription"
                        class="tw-text-lg tw-font-medium tw-leading-6 tw-text-gray-900"
                        >Meeting summary<span
                          v-if="!campaign.booking.description"
                          class="tw-text-red-500 tw-m-0 tw-text-sm tw-ms-2 tw-bg-red-50 tw-py-1 tw-px-2 tw-rounded"
                          >required field</span
                        ></label
                      >
                      <textarea
                        rows="10"
                        v-model="campaign.booking.description"
                        name="bookingDescription"
                        id="bookingDescription"
                        :class="{
                          'tw-ring-red-300': !campaign.booking.description,
                          'tw-ring-green-500': campaign.booking.description,
                        }"
                        class="tw-block tw-p-4 tw-w-full tw-rounded-lg tw-border-0 tw-border-solid tw-text-gray-900 tw-shadow tw-ring-1 tw-ring-inset tw-ring-gray-300 placeholder:tw-text-gray-400 focus:tw-ring-2 focus:tw-ring-inset focus:tw-ring-blue-600 sm:tw-text-lg"
                      ></textarea>
                    </BlockStack>
                  </BlockStack>
                </template>
              </BlockStack>
            </template>
            <template v-else>
              <p class="tw-text-xl tw-leading-8 tw-text-gray-700 tw-mt-3">
                Connect your Office365 account to require a recipient to take a
                meeting with you in order to accept their gift and have meetings
                booked on your calendar in real-time any time a lead accepts
                your e-gift terms.
              </p>
            </template>
          </TheBox>
        </TheCard>
      </PageSection>
    </ThePage>
  </template>
  <template
    v-if="currentStep === 6 && !campaignsAreLoading && !campaignIsSaving"
  >
    <ThePage customWidthClass="tw-max-w-5xl tw-mx-auto">
      <!-- no CC banner -->
      <PageSection title="Campaign Details" class="tw-w-full">
        <template v-if="!paymentInformation">
          <div
            class="tw-max-w-5xl tw-border-red-400 tw-bg-red-50 tw-border-l-4 tw-py-2 tw-px-4 tw-border-y-0 tw-border-r-0 tw-border-solid tw-flex tw-items-center tw-gap-4 tw-w-full tw-mx-auto tw-mb-3"
          >
            <b-icon-exclamation-circle
              class="tw-text-red-700"
            ></b-icon-exclamation-circle>
            <p class="tw-text-sm tw-m-0 tw-text-start tw-text-red-700">
              We couldn't find a credit card on your profile. Please add a
              credit card
              <RouterLink to="/account" class="tw-font-bold">here</RouterLink>
              to able to send campaigns.
            </p>
          </div>
        </template>
        <div
          class="tw-flex gap-2 tw-w-full"
          :class="{ 'tw-flex-col': campaignType === 'email' }"
        >
          <TheCard :fullWidth="true">
            <CardBody>
              <TheBox :withPadding="true">
                <BlockStack :gap="800">
                  <template v-if="this?.campaign?.recipients">
                    <BlockStack :gap="300">
                      <h2
                        class="tw-text-lg tw-font-semibold tw-text-gray-900 tw-m-0"
                      >
                        Recipients
                      </h2>
                      <BlockStack :gap="200">
                        <template v-if="this?.campaign?.recipients">
                          <CampaignRecipientsSelection
                            :campaignRecipients="this?.campaign?.recipients"
                            :readOnlyView="true"
                          >
                          </CampaignRecipientsSelection>
                        </template>
                      </BlockStack>
                    </BlockStack>
                  </template>
                  <template v-if="this?.campaign?.metadata">
                    <BlockStack :gap="300">
                      <h2
                        class="tw-text-lg tw-font-semibold tw-text-gray-900 tw-m-0"
                      >
                        Gift card
                      </h2>
                      <BlockStack :gap="400">
                        <template v-if="this?.campaign?.metadata">
                          <div class="sm:tw-flex tw-items-center">
                            <h4
                              class="tw-font-medium tw-text-gray-900 sm:tw-w-64 sm:tw-flex-none sm:tw-pr-6 tw-m-0"
                            >
                              Card amount
                            </h4>
                            <div class="tw-flex tw-items-center tw-gap-2">
                              <p
                                class="tw-text-sm tw-font-bold tw-text-gray-900 tw-text-center tw-m-0"
                              >
                                ${{ this.giftCardAmount }}.00
                              </p>
                              <TheTooltip
                                :toolTip="true"
                                :tooltipContent="giftCardAmountTooltipContent"
                              >
                                <template #icon>
                                  <div
                                    class="tw-w-4 tw-h-4 tw-rounded-full tw-border-solid tw-border tw-border-gray-500 tw-flex tw-items-center tw-justify-center hover:tw-bg-slate-100 tw-me-2 tw-cursor-pointer"
                                  >
                                    <b-icon-exclamation
                                      class="tw-text-black tw-z-0"
                                    ></b-icon-exclamation>
                                  </div>
                                </template>
                              </TheTooltip>
                            </div>
                          </div>
                          <div class="sm:tw-flex tw-items-center">
                            <h4
                              class="tw-font-medium tw-text-gray-900 sm:tw-w-64 sm:tw-flex-none sm:tw-pr-6 tw-m-0"
                            >
                              Gift card selection
                            </h4>
                            <div class="tw-flex tw-items-center tw-gap-2">
                              <p
                                class="tw-text-sm tw-font-bold tw-text-gray-900 tw-text-center tw-m-0"
                              >
                                {{
                                  this.isCustomGiftCardSelection
                                    ? "Custom selection"
                                    : "Recipients choice"
                                }}
                              </p>
                              <TheTooltip
                                :toolTip="true"
                                :tooltipContent="
                                  giftCardSelectionTooltipContent
                                "
                              >
                                <template #icon>
                                  <div
                                    class="tw-w-4 tw-h-4 tw-rounded-full tw-border-solid tw-border tw-border-gray-500 tw-flex tw-items-center tw-justify-center hover:tw-bg-slate-100 tw-me-2 tw-cursor-pointer"
                                  >
                                    <b-icon-exclamation
                                      class="tw-text-black tw-z-0"
                                    ></b-icon-exclamation>
                                  </div>
                                </template>
                              </TheTooltip>
                            </div>
                          </div>
                          <div class="sm:tw-flex tw-items-center">
                            <h4
                              class="tw-font-medium tw-text-gray-900 sm:tw-w-64 sm:tw-flex-none sm:tw-pr-6 tw-m-0"
                            >
                              Send mode
                            </h4>
                            <div class="tw-flex tw-items-center tw-gap-2">
                              <p
                                class="tw-text-sm tw-font-bold tw-text-gray-900 tw-text-center tw-m-0 tw-capitalize"
                              >
                                {{ this.campaignType }}
                              </p>
                              <TheTooltip
                                :toolTip="true"
                                :tooltipContent="sendModeTooltipContent"
                              >
                                <template #icon>
                                  <div
                                    class="tw-w-4 tw-h-4 tw-rounded-full tw-border-solid tw-border tw-border-gray-500 tw-flex tw-items-center tw-justify-center hover:tw-bg-slate-100 tw-me-2 tw-cursor-pointer"
                                  >
                                    <b-icon-exclamation
                                      class="tw-text-black tw-z-0"
                                    ></b-icon-exclamation>
                                  </div>
                                </template>
                              </TheTooltip>
                            </div>
                          </div>
                          <div class="sm:tw-flex tw-items-start">
                            <h4
                              class="tw-font-medium tw-text-gray-900 sm:tw-w-64 sm:tw-flex-none sm:tw-pr-6 tw-m-0"
                            >
                              Campaign terms
                            </h4>
                            <template v-if="campaign?.booking?.required">
                              <BlockStack :gap="200">
                                <p
                                  class="tw-text-sm tw-font-bold tw-text-gray-900 tw-text-left tw-m-0"
                                >
                                  Recipients will be required to accept a
                                  calendar invite in order to redeem their gift.
                                </p>
                                <BlockStack :gap="300" class="tw-grow">
                                  <BlockStack :gap="100" class="tw-grow">
                                    <label
                                      for="bookingSummary"
                                      class="tw-text-sm tw-font-medium tw-leading-6 tw-text-gray-900"
                                      >Meeting title</label
                                    >
                                    <input
                                      v-model="campaign.booking.summary"
                                      type="text"
                                      name="bookingSummary"
                                      id="bookingSummary"
                                      class="tw-block read-only:tw-bg-gray-100 tw-w-full tw-rounded-md tw-border-0 tw-px-4 tw-py-2 tw-text-gray-900 tw-ring-1 tw-ring-inset tw-ring-gray-300 placeholder:tw-text-gray-400 focus:tw-ring-2 focus:tw-ring-inset focus:tw-ring-blue-600 tw-text-sm tw-leading-6"
                                      readOnly
                                    />
                                  </BlockStack>
                                  <BlockStack :gap="100" class="tw-grow">
                                    <label
                                      for="bookingDescription"
                                      class="tw-text-sm tw-font-medium tw-leading-6 tw-text-gray-900"
                                      >Meeting summary</label
                                    >
                                    <textarea
                                      rows="3"
                                      v-model="campaign.booking.description"
                                      name="bookingDescription"
                                      id="bookingDescription"
                                      class="tw-block read-only:tw-bg-gray-100 tw-p-4 tw-w-full tw-rounded-lg tw-border-0 tw-border-solid tw-text-gray-900 tw-shadow tw-ring-1 tw-ring-inset tw-ring-gray-300 placeholder:tw-text-gray-400 focus:tw-ring-2 focus:tw-ring-inset focus:tw-ring-blue-600 sm:tw-text-sm"
                                      readOnly
                                    ></textarea>
                                  </BlockStack>
                                </BlockStack>
                              </BlockStack>
                            </template>
                            <template v-else>
                              <p
                                class="tw-text-sm tw-font-bold tw-text-gray-900 tw-text-left tw-m-0"
                              >
                                Recipients are NOT required to accept a calendar
                                invite in order to redeem their gift.
                              </p>
                            </template>
                          </div>
                        </template>
                      </BlockStack>
                    </BlockStack>
                  </template>
                </BlockStack>
              </TheBox>
            </CardBody>
          </TheCard>
          <template v-if="campaignType === 'email'">
            <TheCard :autoWidth="true">
              <CardHeader :showTitle="true" title="Email content"> </CardHeader>

              <TheBox
                customClass="tw-px-4 sm:tw-px-6 tw-pt-0 tw-pb-4 sm:tw-pb-6"
              >
                <BlockStack :gap="400" class="tw-w-full tw-text-start">
                  <BlockStack :gap="200" class="tw-w-full tw-text-start">
                    <h2
                      class="tw-text-lg tw-font-semibold tw-text-gray-900 tw-m-0"
                    >
                      Subject
                    </h2>
                    <BlockStack :gap="200" class="tw-text-start">
                      <template v-if="this?.campaign?.recipients">
                        <input
                          v-model="campaign.subject"
                          type="text"
                          name="campaignSubject"
                          id="campaignSubject"
                          class="tw-block read-only:tw-bg-gray-100 tw-w-96 tw-rounded-md tw-border-0 tw-px-2.5 tw-py-1.5 tw-text-gray-900 tw-ring-1 tw-ring-inset tw-ring-gray-300 placeholder:tw-text-slate-900 focus:tw-ring-2 focus:tw-ring-inset focus:tw-ring-blue-600 tw-text-sm tw-leading-6"
                          readonly
                        />
                      </template>
                    </BlockStack>
                  </BlockStack>
                  <BlockStack :gap="200" class="tw-w-full tw-text-start">
                    <h2
                      class="tw-text-lg tw-font-semibold tw-text-gray-900 tw-m-0"
                    >
                      Body
                    </h2>
                    <table
                      id="main_table"
                      style="
                        border-collapse: collapse;
                        text-align: center;
                        background-color: #fff;
                        width: 100%;
                        border: 1px solid #efeeea;
                      "
                    >
                      <tr>
                        <td
                          id="email_from_container"
                          style="
                            padding: 24px;
                            padding-bottom: 0px;
                            text-align: left;
                            background-color: #fff;
                          "
                        >
                          <p style="margin: 0; color: rgb(0, 0, 0)">
                            {{ campaignFromName }} sent you an
                            <span style="font-weight: bold"
                              >STL eGift card</span
                            >
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td
                          id="email_text_container"
                          style="
                            padding: 24px;
                            text-align: left;
                            background-color: #fff;
                            min-height: 200px;
                          "
                        >
                          <template v-if="campaignText">
                            <div
                              style="min-height: 150px"
                              v-html="generatedHtml"
                            ></div>
                          </template>
                          <template v-else>
                            <div class="d-flex align-items-center gap-2">
                              <img
                                style="max-height: 100px; width: auto"
                                src="../../assets/svg/illustrations-test/75_pencil.png"
                                alt="Image Description"
                              />

                              <div class="text-start">
                                <p class="fs-4 mb-0">
                                  Your message will show up here.
                                </p>
                              </div>
                            </div>
                          </template>
                        </td>
                      </tr>
                      <tr>
                        <td
                          id="email_accept_container"
                          style="padding: 24px; background-color: #f6f6f4"
                        >
                          <table
                            id="nested_table_1"
                            style="
                              width: 100%;
                              margin: 0 auto;
                              border-collapse: collapse;
                            "
                          >
                            <tr>
                              <td
                                id="nested_table_1_td_1"
                                style="
                                  text-align: left;
                                  padding-right: 5px;
                                  vertical-align: middle;
                                  height: 100%;
                                  max-width: 70%;
                                "
                              >
                                <p
                                  style="
                                    margin: 0;
                                    color: rgb(0, 0, 0);
                                    font-size: 16px;
                                  "
                                >
                                  Powered by
                                  <span style="font-weight: bold"
                                    >Bold Xchange</span
                                  >
                                </p>
                                <p style="margin: 5px 0 0; color: rgb(0, 0, 0)">
                                  Enjoy an eGift card marketplace featuring many
                                  of St. Louis’ best small businesses.
                                </p>
                              </td>
                              <td
                                id="nested_table_1_td_2"
                                style="
                                  text-align: center;
                                  padding: 0;
                                  height: 100%;
                                  width: 30%;
                                "
                              >
                                <span
                                  style="
                                    text-align: center;
                                    background-color: #004aad;
                                    border-radius: 6px;
                                    color: #ffcc48;
                                    font-weight: bold;
                                    font-style: normal;
                                    padding: 16px 24px;
                                    font-size: 16px;
                                    text-decoration: none;
                                    display: inline-block;
                                    width: auto;
                                  "
                                  >Accept</span
                                >
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td
                          id="email_contact_container"
                          style="padding: 24px; background-color: #fff"
                        >
                          <table
                            id="nested_table_2"
                            style="
                              width: 100%;
                              margin: 0 auto;
                              border-collapse: collapse;
                            "
                          >
                            <tr>
                              <td>
                                <a
                                  href="https://boldxchange.com"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style="color: rgb(0, 0, 0)"
                                >
                                  <img
                                    alt="Gifting Powered by Bold Xchange"
                                    title="Bold Xchange"
                                    src="https://storage.googleapis.com/boldxchange-public/Bold_Xchange_PrimaryLogo_Black_Email.png"
                                    style="width: 175px; height: auto"
                                  />
                                </a>
                                <p
                                  style="margin: 10px 0 0; color: rgb(0, 0, 0)"
                                >
                                  Bold Xchange P.O Box 771576 St. Louis, MO
                                  63177
                                </p>
                                <p
                                  style="
                                    margin: 0;
                                    margin-bottom: 0;
                                    color: rgb(0, 0, 0);
                                  "
                                >
                                  <a
                                    style="
                                      text-decoration: underline;
                                      color: rgb(7, 7, 7);
                                    "
                                    href="mailto:gifts@boldxchange.com"
                                    >gifts@boldxchange.com</a
                                  >
                                </p>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td
                          id="email_copyright_container"
                          style="
                            padding: 24px;
                            text-align: center;
                            background-color: #fff;
                          "
                        >
                          <p
                            style="
                              text-align: center;
                              background-color: #fff;
                              margin: 0;
                              color: rgb(7, 7, 7);
                            "
                          >
                            <em> Copyright (C) 2024 Bold Xchange, Inc.</em>
                          </p>
                        </td>
                      </tr>
                    </table>
                  </BlockStack>
                </BlockStack>
              </TheBox>
            </TheCard>
          </template>
        </div>
      </PageSection>
    </ThePage>
  </template>

  <div class="">
    <PageHeader
      :showActions="true"
      class="tw-fixed tw-bottom-0 tw-inset-x-auto tw-right-0"
    >
      <template #subheading-content>
        <template v-if="nameEditIsActive">
          <div class="tw-flex tw-gap-2 tw-items-center">
            <input
              v-model="newCampaignName"
              type="text"
              id="campaignName"
              placeholder="Campaign name"
              class="tw-block tw-min-w-72 tw-w-full tw-rounded-md tw-border-0 tw-px-2.5 tw-py-1.5 tw-text-gray-900 tw-ring-1 tw-ring-inset tw-ring-gray-300 placeholder:tw-text-slate-900 focus:tw-ring-2 focus:tw-ring-inset focus:tw-ring-blue-600 tw-text-sm tw-leading-6"
            />
            <div class="tw-flex tw-gap-2 tw-items-center">
              <TheButton
                size="small"
                variant="success"
                :disabled="campaignIsSaving"
                @click="updateCampaign()"
              >
                <template #text>Save</template>
              </TheButton>
              <TheButton
                size="small"
                variant="tertiary"
                :disabled="campaignIsSaving"
                @click="cancelEditingCampaignName()"
              >
                <template #text>Cancel</template>
              </TheButton>
            </div>
          </div>
        </template>
        <template v-if="!nameEditIsActive">
          <div class="tw-flex tw-items-center tw-gap-2 tw-flex-wrap">
            <h2 class="tw-text-lg tw-text-blue-900 tw-m-0">
              {{ campaignName }}
            </h2>
            <TheButton
              size="small"
              variant="tertiary"
              :disabled="campaignIsSaving"
              @click="editCampaignName()"
              :hasLeadingIcon="true"
            >
              <template #leading-icon><b-icon-pencil></b-icon-pencil></template>
              <template #text>Edit name</template>
            </TheButton>
          </div>
        </template>
      </template>

      <template #page-header-actions>
        <template
          v-if="allStepsComplete && campaignIsComplete && currentStep !== 6"
        >
          <TheButton
            :class="{ 'tw-animate-pulse': this.currentStep }"
            variant="success"
            @click="handleStepChange(6)"
            size="large"
          >
            <template #text> Finish review </template>
          </TheButton>
        </template>
        <template
          v-if="allStepsComplete && campaignIsComplete && currentStep === 6"
        >
          <TheButton
            :disabled="!paymentInformation"
            :class="{
              'tw-animate-pulse': this.currentStep && paymentInformation,
            }"
            :hasTrailingIcon="!campaignIsSaving && !campaignsAreLoading"
            :hasLeadingIcon="campaignIsSaving || campaignsAreLoading"
            variant="success"
            @click="handleSendingCampaign()"
            size="large"
          >
            <template v-if="campaignIsSaving || campaignsAreLoading">
              <div role="status">
                <svg
                  aria-hidden="true"
                  class="tw-inline tw-w-4 tw-h-4 tw-text-gray-200 tw-animate-spin dark:tw-text-gray-600 tw-fill-blue-600"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </svg>
                <span class="tw-sr-only">Sending...</span>
              </div>
            </template>
            <template #text>
              <template v-if="campaignIsSaving || campaignsAreLoading"
                >Sending campaign</template
              >
              <template v-else>Send campaign</template>
            </template>

            <template #trailing-icon>
              <template v-if="currentStep !== 5">
                <b-icon-arrow-right></b-icon-arrow-right>
              </template>
            </template>
          </TheButton>
        </template>
        <template v-if="!allStepsComplete || !campaignIsComplete">
          <TheButton
            :disabled="
              (currentStep === 5 && !allStepsComplete) ||
              campaignIsSaving ||
              campaignsAreLoading
            "
            :hasTrailingIcon="!campaignIsSaving && !campaignsAreLoading"
            :hasLeadingIcon="campaignIsSaving || campaignsAreLoading"
            variant="secondary"
            @click="goToNextStep()"
            size="large"
          >
            <template #leading-icon>
              <template v-if="campaignIsSaving || campaignsAreLoading">
                <div role="status">
                  <svg
                    aria-hidden="true"
                    class="tw-inline tw-w-4 tw-h-4 tw-text-gray-200 tw-animate-spin dark:tw-text-gray-600 tw-fill-blue-600"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="currentColor"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentFill"
                    />
                  </svg>
                  <span class="tw-sr-only">Saving...</span>
                </div>
              </template>
              <template v-else><b-icon-plus-lg></b-icon-plus-lg></template>
            </template>
            <template #text>
              <template v-if="campaignIsSaving || campaignsAreLoading"
                >Saving</template
              >
              <template v-else>Save and continue</template>
            </template>
            <template #trailing-icon>
              <template v-if="currentStep !== 5">
                <b-icon-arrow-right></b-icon-arrow-right>
              </template>
            </template>
          </TheButton>
        </template>
      </template>
    </PageHeader>
  </div>
</template>

<script>
import CampaignRecipientsSelection from "../../components-v2/campaigns/CampaignRecipientsSelection";
import ThePage from "../../components-v2/ui/layout/ThePage.vue";
import PageHeader from "../../components-v2/ui/layout/PageHeader.vue";
import TheCard from "../../components-v2/ui/layout/TheCard.vue";
import CardHeader from "../../components-v2/ui/layout/CardHeader.vue";
import CardBody from "../../components-v2/ui/layout/CardBody.vue";
import TheBox from "../../components-v2/ui/layout/TheBox.vue";
import BlockStack from "../../components-v2/ui/layout/BlockStack.vue";
import TheButton from "@/components-v2/ui/actions/TheButton.vue";
import TheLink from "@/components-v2/ui/actions/TheLink.vue";
import TheModal from "../../components-v2/ui/modals/TheModal.vue";
import ModalBody from "../../components-v2/ui/layout/ModalBody.vue";
import SuccessContent from "../../components-v2/ui/modals/SuccessContent.vue";
import RecipientsIndexTableV2 from "../../components-v2/recipients/RecipientsIndexTableV2";
import GiftCardsGridV2 from "../../components-v2/gift-cards/GiftCardsGridV2.vue";
import PageSection from "../../components-v2/ui/layout/PageSection.vue";
import ListSkeleton from "../../components-v2/ui/skeletons/ListSkeleton.vue";
import PulseAnimation from "../../components-v2/ui/feedback/PulseAnimation.vue";
import NotificationMessage from "../../components-v2/ui/feedback/NotificationMessage.vue";
import TheTooltip from "../../components-v2/ui/forms/TheTooltip.vue";

import { getDefaultPaymentInformation } from "@/services/stripeService";
import { listMailCampaignById } from "@/services/campaignService";
import {
  upsertMailCampaign,
  sendMailCampaign,
} from "@/services/campaignService";

import {
  // startLinkingGoogle,
  startLinkingOffice365,
} from "@/services/integrationService";

export default {
  name: "CampaignBuilder",
  components: {
    TheTooltip,
    CampaignRecipientsSelection,
    TheBox,
    BlockStack,
    GiftCardsGridV2,
    ThePage,
    PageHeader,
    TheLink,
    RecipientsIndexTableV2,
    TheCard,
    CardHeader,
    CardBody,
    TheButton,
    TheModal,
    ModalBody,
    SuccessContent,
    PageSection,
    ListSkeleton,
    PulseAnimation,
    NotificationMessage,
  },
  async created() {
    await this.getDefaultPaymentInformation();
    await this.loadCampaignDetails();
    this.loadSteps();
  },
  watch: {
    "campaign.text": {
      handler: "loadSteps",
      deep: true,
    },
    "campaign.subject": {
      handler: "loadSteps",
      deep: true,
    },
    "campaign.booking.summary": {
      handler: "loadSteps",
      deep: true,
    },
    "campaign.booking.description": {
      handler: "loadSteps",
      deep: true,
    },
    currentStep: {
      handler: "loadSteps",
      deep: true,
    },
  },
  data() {
    return {
      campaign: {},
      defaultPaymentInformation: {},
      sentMessage: {
        email: {
          successful: {
            show: false,
          },
          failed: {
            text: "We experienced some issues while attempting to send your mail campaign. Please try again.",
            class: "alert-soft-danger alert-dismissible fade show",
            show: false,
          },
        },
        link: {
          successful: {
            show: false,
          },
          failed: {
            text: "We experienced some issues while attempting to send your shareable link campaign. Please try again.",
            class: "alert-soft-danger alert-dismissible fade show",
            show: false,
          },
        },
      },
      calendarState: {
        google: false,
        office365: false,
      },
      booking: null,
      steps: [
        { id: 1, name: "Pick recipients", status: 0 },
        { id: 2, name: "Set gift card amount", status: 0 },
        { id: 3, name: "Select gift cards", status: 0 },
        { id: 4, name: "Choose send mode", status: 0 },
        { id: 5, name: "Set campaign terms", status: 0 },
        { id: 6, name: "Review details", status: 0 },
      ],
      newCampaignName: "",
      currentStep: 1,
      linkCopied: false,
      showSuccessModal: true,
      giftCardAmountIsValid: false,
      customGiftCardValueSelected: false,
      isToggled: false,
      campaignsAreLoading: true,
      campaignIsSaving: false,
      campaignIsComplete: false,
      showGlobalError: false,
      showCampaignRecipients: false,
      nameEditIsActive: false,
    };
  },
  computed: {
    // User
    User() {
      return this?.$store?.state?.auth?.user;
    },
    userId() {
      return this.$store?.state?.auth?.user?._id;
    },
    // Steps
    getSteps() {
      return this.steps;
    },
    // Campaign from details
    campaignFromEmail() {
      return this?.campaign?.from?.email;
    },
    campaignFromName() {
      return this?.campaign?.from?.name;
    },
    // Campaign recipients
    recipientPageSectionTitle() {
      return this?.campaign?.recipients?.length === 0
        ? "Pick recipients for this campaign"
        : "Great, you've picked recipients for your campaign!";
    },
    // tooltip content
    recipientsSectionTooltipContent() {
      return "Currently, multi-recipient campaigns can only be sent using a shareable link.";
    },
    giftCardSelectionTooltipContent() {
      return this.isCustomGiftCardSelection
        ? "Recipients first see your curated list of e-gift cards, but they can always explore and choose any card from the Bold collection."
        : "Recipients get to explore and pick any e-gift card from the Bold collection.";
    },
    giftCardAmountTooltipContent() {
      return "The cash value of the e-gift card that recipients can redeem.";
    },
    sendModeTooltipContent() {
      return this.campaignType === "link"
        ? "You'll receive a unique link to share your campaign with your recipients exactly how you want."
        : "We'll send your campaign through our email builder, complete with an e-gift card link for easy recipient engagement.";
    },
    campaignRecipients() {
      return (
        this?.campaign?.recipients?.map((recipient) => recipient._id) || []
      );
    },
    recipientName() {
      return (
        this?.campaign?.recipients[0]?.firstName +
        " " +
        this?.campaign?.recipients[0]?.lastName
      );
    },
    recipientEmail() {
      return this?.campaign?.recipients[0]?.contact?.email;
    },
    // Campaign subject
    campaignSubject() {
      return this?.campaign?.subject;
    },
    // Campaign text
    campaignText() {
      return this?.campaign?.text?.trim()?.length > 0
        ? this?.campaign?.text?.trim()
        : "";
    },
    campaignGiftUrl() {
      return `${window.location.origin}/gift/${this?.campaign?._id}`;
    },
    // Campaign HTML
    campaignHtml() {
      return this.getEmailHtml();
    },
    generatedHtml() {
      // Split the input message into lines
      const lines = this.campaign.text.split("\n");

      // Generate HTML code with styling
      let htmlCode = "";
      let consecutiveEmptyLines = 0;

      for (let index = 0; index < lines.length; index++) {
        const line = lines[index].trim();

        if (line !== "") {
          if (consecutiveEmptyLines > 0) {
            // Add <br/> for consecutive empty lines
            for (let i = 0; i < consecutiveEmptyLines; i++) {
              htmlCode += "<br/>";
            }
            consecutiveEmptyLines = 0; // Reset consecutive empty lines count
          }

          htmlCode += `<p style="margin: 0;color: rgb(0, 0, 0);">${line}</p>`;
        } else {
          consecutiveEmptyLines++;
        }
      }

      return `${htmlCode}`;
    },
    // Campaign name
    campaignName() {
      return this?.campaign?.metadata?.campaign_name
        ? this?.campaign?.metadata?.campaign_name
        : "Untitled Campaign";
    },
    // Campaign type
    campaignType() {
      return this?.campaign?.metadata?.campaign_type;
    },
    // Gift card amount
    giftCardAmount() {
      return parseInt(this?.campaign?.metadata?.gift_card_amount) || 0;
    },
    // gift card selection
    isCustomGiftCardSelection() {
      return this?.campaign?.metadata?.collection_query?.custom_selection_ids &&
        this?.campaign?.metadata?.collection_query?.custom_selection_ids
          .length > 0
        ? true
        : false;
    },
    // Vendor ids of custom gift card selection
    customSelection() {
      return this?.campaign?.metadata?.collection_query
        ?.custom_selection_ids === 0 ||
        this?.campaign?.metadata?.collection_query?.custom_selection_ids
          .length === 0
        ? 0
        : this?.campaign?.metadata?.collection_query?.custom_selection_ids;
    },
    // check if all campaign requirement are complete
    allStepsComplete() {
      return (
        this.campaignRecipients.length > 0 &&
        this.giftCardAmount > 0 &&
        ((this.campaignType === "email" &&
          this.campaignSubject &&
          this.campaignText) ||
          this.campaignType === "link")
      );
    },

    paymentInformation() {
      return !!this?.defaultPaymentInformation?.card;
    },

    /** integration tokens */
    hasOffice365Tokens() {
      return this?.$store?.state?.auth?.user?.metadata?.office365?.tokens;
    },
    hasGoogleTokens() {
      return this?.$store?.state?.auth?.user?.metadata?.google?.tokens;
    },

    /** error notifications */
    notificationTypes() {
      return this.$store.getters["alerts/getAlertTypes"];
    },
  },
  methods: {
    /** handle loading campaign by id */
    async loadCampaignDetails() {
      this.campaignsAreLoading = true;
      const campaignId = this.$route.params.campaignId;

      try {
        const response = await listMailCampaignById(campaignId);
        const campaign = response.data.result.records[0];
        this.campaign = campaign;
        if (campaign?.booking?.provider) {
          if (campaign.booking.provider === "google") {
            this.calendarState.google = true;
            this.calendarState.office365 = false;
          } else {
            this.calendarState.google = false;
            this.calendarState.office365 = true;
          }
        }
      } catch (error) {
        this.handleErrorFromAPI(
          error,
          "We couldn't load your campaign. Please reload the page and try again."
        );
      } finally {
        this.campaignsAreLoading = false;
      }
    },

    /** handle sending campaign */
    async handleSendingCampaign() {
      this.campaignIsSaving = true;

      const campaignPatch = this.getFinalCampaignPatch();
      const campaignId = this.campaign._id;

      try {
        // Attempt to upsert the campaign
        await upsertMailCampaign(campaignId, campaignPatch);

        // If the campaign type is "email", proceed to send it
        if (this.campaignType === "email") {
          try {
            await sendMailCampaign(this.campaign._id);
            // If sending succeeds, notify the user accordingly
            this.handleSuccess("email");
          } catch (error) {
            // Handle errors specifically from the send operation
            this.handleErrorFromAPI(
              error,
              "We encountered an issue while sending your email campaign. Please reload the page and try sending it again."
            );
            return; // Return to prevent executing link success message
          }
        } else {
          this.handleSuccess("link");
        }
      } catch (error) {
        // Handle errors from the upsert operation
        this.handleErrorFromAPI(
          error,
          "We encountered an issue while sending your link campaign. Please reload the page and try sending it again."
        );
      } finally {
        this.campaignIsSaving = false;
        this.nameEditIsActive = false;
      }
    },
    getFinalCampaignPatch() {
      const userId = this.User.id;
      const fromEmail = this.campaignFromEmail;
      const fromName = this.campaignFromName;
      const html = this.campaignHtml;
      const recipients = this.campaignRecipients;
      const { subject, text } = this.campaign;
      const { campaign_type } = this.campaign.metadata;
      const status = "sent";

      return {
        from: { email: fromEmail, name: fromName },
        recipients,
        subject,
        text,
        html,
        "metadata.campaign_name": this.campaignName,
        "metadata.campaign_status": status,
        "metadata.campaign_type": campaign_type,
        "metadata.gift_card_amount": this.giftCardAmount,
        "metadata.collection_query.custom_selection_ids": this.customSelection,
        "metadata.collection_query.gift_card_amount": this.giftCardAmount,
        user: userId,
      };
    },

    /** handle upserting a campaign by id */
    async updateCampaign() {
      this.campaignIsSaving = true;

      const campaignPatch = this.getCampaignUpdatePatch();
      const campaignId = this.campaign._id;

      console.log("campaignPatch", campaignPatch);
      try {
        await upsertMailCampaign(campaignId, campaignPatch);
        this.handleSuccess();
        return true;
      } catch (error) {
        this.handleErrorFromAPI(
          error,
          "Something went wrong while attempting to save your campaign. Please try again."
        );
      } finally {
        this.campaignIsSaving = false;
      }
    },
    getCampaignUpdatePatch() {
      const userId = this.User.id;
      const fromEmail = this.campaignFromEmail;
      const fromName = this.campaignFromName;
      const html = this.campaignHtml;

      const recipients = this.campaignRecipients;
      const { subject, text } = this.campaign;
      const campaignType =
        this.campaignRecipients.length > 1
          ? "link"
          : this.campaign.metadata.campaign_type;
      const status = "draft";
      const campaignName =
        this.newCampaignName.trim() !== ""
          ? this.newCampaignName
          : this.campaignName;

      // Initialize the campaign update patch object
      const campaignUpdatePatch = {
        from: { email: fromEmail, name: fromName },
        recipients,
        subject,
        text,
        html,
        "metadata.campaign_name": campaignName,
        "metadata.campaign_status": status,
        "metadata.campaign_type": campaignType,
        "metadata.gift_card_amount": this.giftCardAmount,
        "metadata.collection_query.custom_selection_ids": this.customSelection,
        "metadata.collection_query.gift_card_amount": this.giftCardAmount,
        user: userId,
      };

      // Check if any calendar is selected and summary, description are truthy and not just whitespace
      const isAnyCalendarSelected = Object.values(this.calendarState).some(
        (state) => state === true
      );
      const bookingCompleteAndValid =
        this?.campaign?.booking &&
        this?.campaign?.booking?.summary?.trim() &&
        this?.campaign?.booking?.description?.trim();

      // If conditions are met, add booking to the campaign update patch
      if (isAnyCalendarSelected && bookingCompleteAndValid) {
        campaignUpdatePatch.booking = this.campaign.booking;
      }

      return campaignUpdatePatch;
    },

    /** handle custom gift card selection */
    updateCampaignCustomSelection(selectedCards) {
      this.campaign.metadata.collection_query.custom_selection_ids =
        selectedCards;
      this.loadSteps();
    },

    /** email html */
    getEmailHtml() {
      return this.generatedHtml
        ? `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Email Template</title>
    <style>
      body {
        font-family: Arial, sans-serif;
        color: #241c15;
      }

      table {
        border-collapse: collapse;
      }
    </style>
  </head>
  <body style="font-family: Arial, sans-serif; color: rgb(0, 0, 0)">
    <table
      id="main_table"
      style="
        border-collapse: collapse;
        text-align: center;
        background-color: #fff;
        max-width: 660px;
        width: 100%;
        border: 1px solid #efeeea;
      "
    >
      <tr>
        <td
          id="email_from_container"
          style="
            padding: 24px;
            padding-bottom: 0px;
            text-align: left;
            background-color: #fff;
          "
        >
          <p style="margin: 0; color: rgb(0, 0, 0)">
            ${this.campaignFromName} sent you an
            <span style="font-weight: bold">STL eGift card</span>
          </p>
        </td>
      </tr>
      <tr>
        <td
          id="email_text_container"
          style="
            padding: 24px;
            text-align: left;
            background-color: #fff;
            height: 200px;
            vertical-align: top;
          "
        >
          ${this.generatedHtml}
        </td>
      </tr>
      <tr>
        <td
          id="email_accept_container"
          style="padding: 24px; background-color: #f6f6f4"
        >
          <table
            id="nested_table_1"
            style="width: 100%; margin: 0 auto; border-collapse: collapse"
          >
            <tr>
              <td
                id="nested_table_1_td_1"
                style="
                  text-align: left;
                  padding-right: 5px;
                  vertical-align: middle;
                  height: 100%;
                  max-width: 70%;
                "
              >
                <p style="margin: 0; color: rgb(0, 0, 0); font-size: 16px">
                  Powered by
                  <span style="font-weight: bold">Bold Xchange</span>
                </p>
                <p style="margin: 5px 0 0; color: rgb(0, 0, 0)">
                  Enjoy an eGift card marketplace featuring many of St. Louis’
                  best small businesses.
                </p>
              </td>
              <td
                id="nested_table_1_td_2"
                style="text-align: center; padding: 0; height: 100%; width: 30%"
              >
                <a
                  href="${this.campaignGiftUrl}"
                  target="_blank"
                  style="
                    text-align: center;
                    background-color: #004aad;
                    border-radius: 6px;
                    color: #ffcc48;
                    font-weight: bold;
                    font-style: normal;
                    padding: 16px 24px;
                    font-size: 16px;
                    text-decoration: none;
                    display: inline-block;
                    width: auto;
                  "
                  >Accept</a
                >
              </td>
            </tr>
          </table>
        </td>
      </tr>
      <tr>
        <td
          id="email_contact_container"
          style="padding: 24px; background-color: #fff"
        >
          <table
            id="nested_table_2"
            style="width: 100%; margin: 0 auto; border-collapse: collapse"
          >
            <tr>
              <td>
                <a
                  href="https://boldxchange.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  style="color: rgb(0, 0, 0)"
                >
                  <img
                    alt="Gifting Powered by Bold Xchange"
                    title="Bold Xchange"
                    src="https://storage.googleapis.com/boldxchange-public/Bold_Xchange_PrimaryLogo_Black_Email.png"
                    style="width: 175px; height: auto"
                  />
                </a>
                <p style="margin: 10px 0 0; color: rgb(0, 0, 0)">
                  Bold Xchange P.O Box 771576 St. Louis, MO 63177
                </p>
                <p style="margin: 0; margin-bottom: 0; color: rgb(0, 0, 0)">
                  <a
                    style="text-decoration: underline; color: rgb(7, 7, 7)"
                    href="mailto:gifts@boldxchange.com"
                    >gifts@boldxchange.com</a
                  >
                </p>
              </td>
            </tr>
          </table>
        </td>
      </tr>
      <tr>
        <td
          id="email_copyright_container"
          style="padding: 24px; text-align: center; background-color: #fff"
        >
          <p
            style="
              text-align: center;
              background-color: #fff;
              margin: 0;
              color: rgb(7, 7, 7);
            "
          >
            <em> Copyright (C) 2024 Bold Xchange, Inc.</em>
          </p>
        </td>
      </tr>
    </table>
  </body>
</html>
`
        : "";
    },

    /** handle retrieving default payment information */
    async getDefaultPaymentInformation() {
      this.dataIsLoading = true;

      try {
        const defaultPaymentData = await getDefaultPaymentInformation(
          this.userId
        );

        const paymentInformation = defaultPaymentData;
        this.defaultPaymentInformation = paymentInformation;
      } catch (error) {
        if (
          error?.response?.data?.code === 404 &&
          error?.response?.data?.status === "no_payment_method_found"
        ) {
          console.log("error", error);
          console.log("no payment", error);

          console.error(error);
        } else {
          this.handleErrorFromAPI(
            error,
            "Something went wrong while attempting to retrieve your payment information from Stripe. Please reload the page and try again."
          );
          console.log("defaultPaymentRes error: ", error);
        }
      } finally {
        this.dataIsLoading = false;
      }
    },

    /** handle adding recipients to campaign */
    setCampaignRecipients(newRecipients) {
      const existingIds = new Set(this.campaign.recipients.map((r) => r.id));
      const recipientsToAdd = newRecipients.filter(
        (recipient) => !existingIds.has(recipient.id)
      );

      this.campaign.recipients = [
        ...this.campaign.recipients,
        ...recipientsToAdd,
      ];
      this.loadSteps();
    },

    /** handle removing recipients from campaign */
    removeSelectedCampaignRecipients(recipientsToRemove) {
      const idsToRemove = new Set(recipientsToRemove.map((r) => r.id));
      this.campaign.recipients = this.campaign.recipients.filter(
        (recipient) => !idsToRemove.has(recipient.id)
      );
      this.loadSteps(); // Assuming this method needs to be called here as well
    },
    toggleCampaignRecipients() {
      this.showCampaignRecipients = !this.showCampaignRecipients;
    },

    /** handle gift card amount selection */
    validateCustomGiftCardValue() {
      const trimmedValue = this.campaign.metadata.gift_card_amount.trim();
      const value = parseFloat(trimmedValue);

      // Check if the trimmed value is a valid number and meets the criteria
      if (!Number.isNaN(value) && value >= 5 && Number.isSafeInteger(value)) {
        this.giftCardAmountIsValid = true;
        this.campaign.metadata.gift_card_amount = Math.round(value).toString(); // Convert back to string
        this.loadSteps();
        this.clearTimeoutIfNeeded();
      } else {
        this.clearTimeoutIfNeeded();

        // Reset to "0" string only if the input is not a valid number
        this.timeoutId = setTimeout(() => {
          this.campaign.metadata.gift_card_amount = "0"; // Reset to "0" string
          this.giftCardAmountIsValid = false;
          this.loadSteps();
        }, 350);
      }
    },
    clearTimeoutIfNeeded() {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }
    },
    setGiftCardAmount(value) {
      if (!this.customGiftCardValueSelected) {
        this.campaign.metadata.gift_card_amount = value.toString(); // Convert to string
      }
      this.loadSteps();
    },

    /** handle linking google/office365 */
    async startLinkingGoogle() {
      try {
        /**
         * @type {import('@boldxchange/sdk/defs').Client}
         */

        const api = await this.getBoldClient();
        const redirectUri = {
          redirectUri: window.location.origin + `/integrations/google`,
        };
        const response = await api.startLinkingGoogle(redirectUri);
        const googleUrlRedirect = response?.data?.url;
        window.location.href = googleUrlRedirect;
      } catch (error) {
        console.log(error);
        console.error("Failed to link google", error);
        this.handleErrorFromAPI(error);
      } finally {
        this.isLinking = false;
      }
    },
    async startLinkingOffice365() {
      try {
        /**
         * @type {import('@boldxchange/sdk/defs').Client}
         */

        const api = await this.getBoldClient();

        const redirectUri = {
          redirectUri: window.location.origin + `/integrations/office365`,
        };

        const response = await api.startLinkingOffice365(redirectUri);
        console.log("office365Response", response);
        const office365UrlRedirect = response?.data?.url;
        window.location.href = office365UrlRedirect;
      } catch (error) {
        console.error("Failed to link office365", error);
        this.handleErrorFromAPI(error);
      } finally {
        this.isLinking = false;
      }
    },
    /** handle steps */
    async handleStepChange(step) {
      const successfulRes = await this.updateCampaign();
      if (successfulRes) {
        this.currentStep = step;
        this.loadSteps();
      }
    },
    async goToNextStep() {
      const successfulRes = await this.updateCampaign();
      if (successfulRes) {
        this.currentStep++;
        this.loadSteps();
      }
    },
    loadSteps() {
      const updatedSteps = this.updateSteps(this.campaign, this.steps);
      this.steps = updatedSteps;
    },
    updateSteps(campaign, steps) {
      const recipientsNotEmpty = campaign.recipients.length > 0;
      const giftCardAmountComplete = this.giftCardAmount ? true : false;
      const giftCardSelectionComplete = this.customSelection;
      const emailAndTextComplete =
        campaign.metadata.campaign_type === "email" &&
        campaign.subject &&
        campaign.text;
      const linkType = campaign.metadata.campaign_type === "link";

      const isAnyCalendarSelected = Object.values(this.calendarState).some(
        (state) => state === true
      );

      const bookingSummaryAndDescriptionValid =
        this?.campaign?.booking?.summary?.trim() &&
        this?.campaign?.booking?.description?.trim();

      let bookingComplete = true;

      if (isAnyCalendarSelected && !bookingSummaryAndDescriptionValid) {
        bookingComplete = false;
      }

      // Update Step 1
      this.updateStepStatus(steps, 1, recipientsNotEmpty ? 1 : 0);

      // Update Step 2
      this.updateStepStatus(steps, 2, giftCardAmountComplete ? 1 : 0);

      // Update Step 3
      this.updateStepStatus(steps, 3, giftCardSelectionComplete ? 1 : 0);

      // Update Step 4
      this.updateStepStatus(steps, 4, emailAndTextComplete || linkType ? 1 : 0);

      // Update Step 5
      this.updateStepStatus(steps, 5, bookingComplete || linkType ? 1 : 0);

      // Update Step 5
      const allStepsComplete =
        recipientsNotEmpty &&
        giftCardAmountComplete &&
        giftCardSelectionComplete &&
        bookingComplete &&
        (emailAndTextComplete || linkType);
      this.updateStepStatus(steps, 6, allStepsComplete ? 1 : 0);

      this.campaignIsComplete = allStepsComplete;

      return steps;
    },
    updateStepStatus(steps, stepId, status) {
      const stepIndex = steps.findIndex((step) => step.id === stepId);
      if (stepIndex !== -1) {
        steps[stepIndex].status = status;
      }
    },

    /** handle campaign type selection */
    setCampaignType(type) {
      this.campaign.metadata.campaign_type = type;
      this.loadSteps();
    },
    conditionallySetCampaignTypeToEmail() {
      if (this.campaignRecipients.length <= 1) {
        this.setCampaignType("email");
      }
    },

    /** handle gift card selection toggle */
    handleCalendarSelection(calendar) {
      // Check if we are toggling off the currently selected calendar
      if (this.calendarState[calendar]) {
        // If yes, deselect everything
        this.campaign.booking = {
          provider: calendar,
          summary: "",
          description: "",
          enabled: false,
          required: false,
        };
        Object.keys(this.calendarState).forEach((key) => {
          this.calendarState[key] = false;
        });
      } else {
        // If no, select the new calendar and update the booking information
        Object.keys(this.calendarState).forEach((key) => {
          this.calendarState[key] = key === calendar;
        });
        this.campaign.booking = {
          provider: calendar,
          summary: "",
          description: "",
          enabled: true,
          required: true,
        };
      }
      this.loadSteps();
    },

    /** handle link copy */
    async copyLink() {
      const linkToCopy = this.campaignGiftUrl;
      await navigator.clipboard.writeText(linkToCopy);
      this.linkCopied = true;
    },

    /** handle editing campaign name */
    editCampaignName() {
      this.nameEditIsActive = !this.nameEditIsActive;
    },
    cancelEditingCampaignName() {
      this.nameEditIsActive = !this.nameEditIsActive;
      this.newCampaignName = "";
    },

    /** success and error handling */
    handleSuccess(type) {
      if (type === "link") {
        this.campaignIsSaving = false;
        console.warn("link campaign sent");
        this.sentMessage.link.successful.show = true;
      } else if (type === "email") {
        this.campaignIsSaving = false;
        this.sentMessage.email.successful.show = true;
        console.warn("email campaign sent");
      } else {
        this.$store.dispatch("alerts/showAlert", {
          type: this.notificationTypes.SUCCESS,
          message: "Your campaign was saved.",
          duration: 2000,
          id: Date.now(),
        });
        this.nameEditIsActive = false;
        this.loadCampaignDetails();
        this.campaignIsSaving = false;
        if (this.campaignRecipients.length > 0) {
          this.showCampaignRecipients = true;
        }
      }
    },
    handleErrorFromAPI(error, customMessage = null) {
      let errorMessage = "Something went wrong. Please try again."; // Default message

      // If a custom message is provided, prioritize it
      if (customMessage) {
        errorMessage = customMessage;
      } else if (error?.response) {
        // Process API error message if customMessage is not provided
        if (
          error?.response?.data &&
          error?.response?.data?.error &&
          error?.response?.data?.error?.source?.errors
        ) {
          const sourceErrors = error.response.data.error.source.errors;
          const firstErrorKey = Object.keys(sourceErrors)[0];
          errorMessage = sourceErrors[firstErrorKey].message;
        } else {
          errorMessage =
            error.response.data.message || "An unknown error occurred.";
        }
      } else if (error?.request) {
        errorMessage =
          "No response was received from the server. Please check your internet connection.";
      } else {
        errorMessage = "An error occurred with your request. Please try again.";
      }

      //Dispatch the error message as before
      this.$store.dispatch("alerts/showAlert", {
        type: this.notificationTypes.ERROR,
        message: errorMessage,
        duration: 6000,
        id: Date.now(),
      });
      this.loadingDashboardData = false;
      this.campaignIsSaving = false;
      this.campaignsAreLoading = false;
      console.error(errorMessage); // Keep for debugging purposes
    },
  },
};
</script>

<style scoped></style>
